<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";


    let canClose: boolean = true;
    export let size: 'normal' | 'small' | 'large' = 'normal'

    const dispatch = createEventDispatcher();

    onMount(() => {
    });

    function onClose() {
        console.log('onClose');
        dispatch('click');
    }

    $: buttonClass = (() => {
        const classArray: string[] = [];
        if (canClose) {
            classArray.push('show');
        }
        return classArray;
    })();

    $: lineClass = (() => {
        const classArray: string[] = [];
        classArray.push(size);
        return classArray;
    })();

</script>


<div class={`close-button-view ${size}`} on:click={onClose}>

    <div class="cross-sign">
        <div class="line left-up"></div>
        <div class="line right-up"></div>

    </div>


</div>
<style lang="scss">
    .close-button-view {
        --normal-size: 16px;
        --small-size: 12px;
        --large-size: 40px;
        --line-size: 2px;
        --large-line-size: 4px;

        //opacity: 0;
        //pointer-events: none;
        padding: 4px;

        cursor: pointer;
        transition-duration: 0s;

        width: var(--normal-size);
        height: var(--normal-size);

        border-width: var(--line-size);

        &.small {
            width: var(--small-size);
            height: var(--small-size);

            border-width: var(--line-size);

            .cross-sign {
                .line {
                    height: var(--small-size);
                }
            }
        }

        &.large {
            width: var(--large-size);
            height: var(--large-size);

            border-width: var(--large-line-size);

            .cross-sign {
                .line {
                    height: var(--large-size);
                }

            }
        }


        &:hover {
            transform: rotateZ(90deg);
            background-color: var(--box-background-color);
            border-radius: 50%;
            transition-duration: 0.5s;
        }


        .cross-sign {
            display: flex;
            justify-content: center;
            position: relative;

            width: 100%;
            height: 100%;

            .line {
                background-color: var(--text-color);

                width: var(--line-size);
                height: var(--normal-size);

                position: absolute;


                &.left-up {
                    transform: rotate(-45deg);
                }

                &.right-up {
                    transform: rotate(45deg);
                }
            }
        }
    }
</style>